import React from "react";
import MyNav from "./components/MyNav";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MyNav />
      </header>
    </div>
  );
}

export default App;
